import { Component, inject } from '@angular/core';
import { EquationVariableService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  EquationVariableCreateDto,
  EquationVariableDto,
  EquationVariableExcelDownloadDto,
  EquationVariableUpdateDto,
} from '../proxy/general/dtos/equation-variable';
import { EQUATIONVARIABLE_CONFIG, EQUATIONVARIABLE_FIELDS } from './equation-variable.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-equation-variable',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, EquationVariableService, ConfirmationService],
  templateUrl: './equation-variable.html',
  styleUrl: './equation-variable.scss',
})
export class EquationVariable extends BaseCrudComponent<
  EquationVariableDto,
  EquationVariableCreateDto,
  EquationVariableUpdateDto,
  EquationVariableExcelDownloadDto
> {
  service = inject(EquationVariableService);
  config = EQUATIONVARIABLE_CONFIG;
  fields = EQUATIONVARIABLE_FIELDS;

  protected prepareUpdateDto(data: any, selected: EquationVariableDto): EquationVariableUpdateDto {
    return {
      description: data.description,
      variable: data.variable,
      equationVariableGroupId: data.equationVariableGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'EquationVariable';
  }
}
